import LazyLoad from 'react-lazyload';
import BeforeAfterPhotosContainer from 'components/Shared/BeforeAfter/BeforeAfterPhotosContainer';
import { useTranslation } from 'hooks/useTranslation';
import { RecordType } from 'types/BeforeAfterPhotos';
import type { LocationPage } from 'types/PageData';
import type { APIBeforeAfterPhoto } from 'types/BeforeAfterPhotos';

type Props = {
  entry: LocationPage;
  beforeAfterPhotos: APIBeforeAfterPhoto[];
};

const BeforeAfter = ({
  entry,
  beforeAfterPhotos,
}: Props): JSX.Element | null => {
  const { t } = useTranslation();

  if (!beforeAfterPhotos.length) {
    return null;
  }

  return (
    <LazyLoad once>
      <div className="border-t border-silver-light py-14">
        <div className="max-w-screen-xl mx-auto">
          <div className="lg:grid grid-cols-3">
            <div>
              <h2 className="text-2-188r lg:text-1-938r mb-2 px-5 lg:px-4 pt-0">
                {`${t('doctorProfile.beforeAfterPhotos.title')} ${
                  entry.treatment.treatmentName
                } in ${entry.title as string}`}
              </h2>
            </div>

            <div className="col-span-2 px-5 md:pl-5 lg:px-4">
              <BeforeAfterPhotosContainer
                slug={entry.slug}
                type={RecordType.DOCTOR}
                initialPhotos={beforeAfterPhotos}
              />
            </div>
          </div>
        </div>
      </div>
    </LazyLoad>
  );
};

export default BeforeAfter;
